import React from 'react'
import { updateSubscription } from '../../../../Profile/commands/subscriptions/update'
import { Subscription } from '../../../../Profile/types'
import { changeUnitIndividual } from '../../../../Units/commands/individual'
import { UnitIndividual, UnitMaster } from '../../../../Units/reducer'
import { onError } from '../../../../../utils/onError'
import { onSuccess } from '../../../../../utils/onSuccess'

export const onConfirmCallback = ({
  _individualUnits,
  selectedRow,
  subscriptions,
  onCloseUnitModal,
  onUnitChanged,
}: {
  _individualUnits: UnitMaster[]
  selectedRow: UnitMaster | null
  subscriptions: Subscription[]
  onCloseUnitModal: () => void
  onUnitChanged: (val: UnitMaster) => void
}) => {
  const onConfirmChange = React.useCallback(
    async (val: UnitMaster | null) => {
      if (!selectedRow || !val) return

      const subscription = subscriptions.find(
        (s) => s.subscriptionId === String(selectedRow.subscriptionId)
      )

      const oldUnit = _individualUnits.find((iu) => iu.id === selectedRow?.id)

      if (!oldUnit || !subscription) {
        onError('Could not find the current unit or subscription details.')
        return
      }

      const oldDescription = subscription.order.description
      const size = oldDescription.split('/')?.[0] || ''
      const description = `${size.trim()}/${val.unitNumber}`

      const unit: UnitIndividual = {
        id: val.id,
        isClimate: val.isClimate,
        isCovered: val.isCovered,
        masterId: val.masterId,
        size: val.size,
        unitNumber: val.unitNumber,
        customerProfileId: oldUnit.customerProfileId,
        subscriptionId: oldUnit.subscriptionId,
      }

      try {
        await Promise.all([
          changeUnitIndividual(unit).promise,
          changeUnitIndividual({
            id: oldUnit.id,
            isClimate: oldUnit.isClimate,
            isCovered: oldUnit.isCovered,
            masterId: oldUnit.masterId,
            size: oldUnit.size,
            unitNumber: oldUnit.unitNumber,
          }).promise,
        ])

        await updateSubscription({
          subscriptionId: String(selectedRow.subscriptionId),
          description,
          skipBootstrap: true,
        }).promise

        onUnitChanged({
          ...val,
          customerProfileId: oldUnit.customerProfileId,
          subscriptionId: oldUnit.subscriptionId,
        })
        onSuccess(`Successfully changed unit to ${val.unitNumber}.`)
      } catch (error) {
        onError(
          error instanceof Error ? error.message : 'Failed to change unit.'
        )
      }
    },
    [
      _individualUnits,
      onCloseUnitModal,
      onUnitChanged,
      selectedRow,
      subscriptions,
    ]
  )

  return {
    onConfirmChange,
  }
}
